import { useEffect, useState } from 'react';
import { useInputHelper, DefaultInputPropTypes, splitForApi, FormFieldsData, TextInput } from 'framework/form';

const TicketIdsInput = (props: DefaultInputPropTypes<string[]>) => {
  const inputHelper = useInputHelper(props);
  const [value, setValue] = useState('');

  useEffect(() => {
    const contextValue = inputHelper.getValue();
    setValue(contextValue ? contextValue.join(', ') : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getSource, getRawOnChangeCallback } = inputHelper;

  const onChangeCallback = (object: FormFieldsData) => {
    const source = getSource();
    let rawValue = object[source];
    const rawOnChangeCallback = getRawOnChangeCallback();

    rawValue = rawValue.replace(/[^0-9, ]/g, '');
    setValue(rawValue);

    if (rawOnChangeCallback) {
      rawOnChangeCallback({
        [source]: splitForApi(rawValue),
      });
    }
  };

  return <TextInput {...props} onChangeCallback={onChangeCallback} value={value} />;
};

export default TicketIdsInput;
